enum ServiceAuthorizationStatus {
    NotAuthorized,
    Authorized,
    Declined,
}

export default ServiceAuthorizationStatus;
